import React from "react";


export default function(props){
  return (
      <section className="about">
      <div className="text-container">
         <h1>Full Stack Web Development and JavaScript Applications in SF</h1>
         <hr/>
         <p>
           I'm an experienced software engineer in San Francisco. I've built multiple high traffic advanced responsive web applications. I have taught dozens of students complex technical concepts including Node.js, functional JavaScript, DOM manipulation, MySQL, React, and more. I am passionate about connecting people, improving lives, and creating joyful user experiences. 
         </p>
      </div>
    </section>
    )
}